// src/components/FormikInput.js

import React, { useEffect, useState } from "react"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"
import { useDispatch } from "react-redux"

// #region actions
import { getControlEscolarGetEmail } from "../../../store/actions"
import { use } from "react"
// #endregion

// #region selectors
import {
  useControlEscolarEmail,
  useControlEscolarIsLoadingEmail,
} from "store/selectors"
// #endregion

const FormikInputEmailPersonal = ({
  label,
  name,
  max = 255,
  type = "text",
  placeholder,
  formik,
  onChange,
  mask, // Opcional: si usas InputMask
  showCharacterCounter = false,
  isLoading,
  ...props
}) => {
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region functions

  const handleBlurEmailPersonal = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const email = event.target.value

    // Solo envía la petición si no hay errores
    if (!formik.errors.hasOwnProperty("Email_Personal")) {
      dispatch(
        getControlEscolarGetEmail({
          nombreSolicitud: "buscaemail",
          email: formik.values.Email_Personal,
        })
      )
    }

    // Re-envia el evento
    formik.handleBlur(event)
  }

  // #endregion

  // #region const-selectors
  const email = useControlEscolarEmail()
  const isLoadingEmail = useControlEscolarIsLoadingEmail()
  // #endregion selectors

  // #region Internal States
  // #endregion

  // #region useEffects
  useEffect(() => {
    if (!isLoadingEmail && email.length > 0) {
      if (email === formik.values.Email_Personal) {
        formik.setFieldError("Email_Personal", "Email Personal repetido!")
      }
    }
  }, [isLoadingEmail, email])

  // #endregion

  return (
    <FormGroup>
      <Label htmlFor={name}>{label}</Label>
      {!isLoading ? (
        <>
          <Input
            type={type}
            name={name}
            id={name}
            placeholder={placeholder}
            value={formik.values[name]}
            onChange={onChange || formik.handleChange}
            onBlur={handleBlurEmailPersonal}
            invalid={formik.touched[name] && !!formik.errors[name]}
            maxLength={max} // Limita la entrada a max caracteres
            autoComplete="off"
            {...props}
          />{" "}
          {showCharacterCounter ? (
            <div className="text-end">
              {formik.values[name].length}/{max}
            </div>
          ) : null}
        </>
      ) : (
        <div>
          <p aria-hidden="true" className="mt-2">
            <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
          </p>
        </div>
      )}
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback>{formik.errors[name]}</FormFeedback>
      )}
    </FormGroup>
  )
}

export default FormikInputEmailPersonal
